import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import LoadingComponent from '../../../../components/common/loading/LoadingComponent'
// import SectionButton from '../../../../components/common/ITerminalWizardComponent/SectionButton'
import SectionOne from '../sections/SectionOne'
import SectionTwo from '../sections/SectionTwo'
import pdService from '../../../../services/applicationRegistration/compensation/pdService'
import { FileRegistrationModel } from '../../../../models/applicationRegistration/fileRegistration/fileRegistrationModel'
import { useHistory } from 'react-router'
import {
  getSectionFiveSuccessMessage,
  handleNotification,
} from '../../../../utils/utilFunctions'
import SectionThree from '../sections/SectionThree'
import { PdAggrivedPersonDetailsModel } from '../../../../models/applicationRegistration/compensation/pd/pdAggrivedPerson'
import SectionFour from '../sections/SectionFour'
import ITerminalWizardComponent from '../../../../components/common/ITerminalWizardComponent/ITerminalWizardComponent'
import { useDispatch } from 'react-redux'
import { changeLoadingRequest } from '../../../../store/app/actionTypes'
import { pdSectionList } from '../../../../utils/metaData'
import SectionFive from '../sections/SectionFive'
import { ResponseObject } from '../../../../services/api/apiManager'
import DialogModal from '../../../../components/modals/DialogModal'
import { applicationReadyToModify } from '../../../../utils/constants'
import SectionTwoView from '../../../../components/sections/SectionTwo'
import SectionThreeView from '../../../../components/sections/SectionThree'
import SectionFourView from '../../../../components/sections/SectionFour'
import SectionFiveView from '../../../../components/sections/SupportDocumentSection'

const PdFileRegistration = (props: any) => {
  const {
    type,
    match: { params },
  } = props
  console.log(type)
  console.log(params)
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [activeSection, setActiveSection] = useState(1)
  const [fileRegistrationObject, setFileRegistrationObject] = useState(
    {} as FileRegistrationModel
  )
  const history = useHistory()
  const dispatch = useDispatch()
  async function getFileDetails() {
    const result = await pdService.apiFetchPdFile(parseInt(params.id))
    console.log(result)
    setFileRegistrationObject(result.data)
    setLoading(false)
  }
  useEffect(() => {
    getFileDetails()
  }, [])

  const handleOk = () => {
    history.goBack()
  }

  const handleCancel = () => {
    history.goBack()
  }

  const handleProceed = async () => {
    dispatch(changeLoadingRequest())
    const result = await pdService.apiPdProceed(fileRegistrationObject)
    handleNotification(result, 'Application Drafted Successfully')
    if (result.status === 200) {
      setFileRegistrationObject(result.data)
      setActiveSection(activeSection + 1)
    }
    dispatch(changeLoadingRequest())
  }

  const handleReject = async (remark: string) => {
    dispatch(changeLoadingRequest())
    const result = await pdService.apiPdReject(
      fileRegistrationObject.id,
      remark
    )
    dispatch(changeLoadingRequest())
    handleNotification(result, 'Application Reject Successfully')
    if (result.status === 200) {
      history.goBack()
    }
  }

  const handleReturn = async (remark: string) => {
    dispatch(changeLoadingRequest())
    const result = await pdService.apiPdReturn(
      fileRegistrationObject.id,
      remark
    )
    dispatch(changeLoadingRequest())
    handleNotification(result, 'Application Return Successfully')
    if (result.status === 200) {
      history.goBack()
    }
  }

  const handleSectionTwo = async (
    type: string,
    sectionTwo: FileRegistrationModel
  ) => {
    dispatch(changeLoadingRequest())
    const result = await pdService.apiPdAddApplicantDetails(sectionTwo)
    handleNotification(result, 'Application Drafted Successfully')
    if (result.status === 200) {
      setFileRegistrationObject(result.data)
      if (type === 'next') {
        setActiveSection(activeSection + 1)
      }
    }
    dispatch(changeLoadingRequest())
  }

  const handleSectionThree = async (
    type: string,
    sectionThree: PdAggrivedPersonDetailsModel
  ) => {
    dispatch(changeLoadingRequest())
    const result = await pdService.apiPdAddAggrivedPersonDetailsDetails(
      sectionThree
    )
    handleNotification(result, 'Application Drafted Successfully')
    if (result.status === 200) {
      const pdFile = await pdService.apiFetchPdFile(parseInt(params.id))
      setFileRegistrationObject(pdFile.data)
      if (type === 'next') {
        setActiveSection(activeSection + 1)
      }
    }
    dispatch(changeLoadingRequest())
  }

  const handleSectionFour = async (type: string) => {
    const pdFile = await pdService.apiFetchPdFile(parseInt(params.id))
    setFileRegistrationObject(pdFile.data)
    if (type === 'next') {
      setActiveSection(activeSection + 1)
    }
  }

  const handleSectionFive = async (type: string, formData: FormData) => {
    dispatch(changeLoadingRequest())
    let result = {} as ResponseObject
    let message = 'Application Drafted Successfully'
    if (type === 'save') {
      console.log(formData)
      result = await pdService.apiPdAddSupportingDocument(
        formData,
        fileRegistrationObject.id
      )
    } else {
      message = getSectionFiveSuccessMessage(fileRegistrationObject)
      result = await pdService.apiPdRegisterDocument(fileRegistrationObject.id)

      if (result.status === 200) {
        const pdFile = await pdService.apiFetchPdFile(parseInt(params.id))
        setFileRegistrationObject(pdFile.data)
        if (type === 'submit') {
          setShowModal(true)
        }
      }
    }
    handleNotification(result, message)
    dispatch(changeLoadingRequest())
  }

  const handleModify = async () => {
    dispatch(changeLoadingRequest())
    const result = await pdService.apiPdModify(fileRegistrationObject)
    handleNotification(result, applicationReadyToModify)
    if (result.status === 200) {
      setFileRegistrationObject(result.data)
      setActiveSection(activeSection + 1)
    }
    dispatch(changeLoadingRequest())
  }

  const handleNextClick = () => {
    setActiveSection(activeSection + 1)
  }

  return (
    <>
      {loading ? (
        <div className="loading-layout">
          <LoadingComponent />
        </div>
      ) : (
        <>
          <Row className="title-layout">
            <Col className="d-flex justify-content-start">
              <span className="compensation-title mt-2 mb-2 ml-2">
                Application Registration
              </span>
              <span className="m-2">
                {`Application reference : ${fileRegistrationObject.referenceNumber}`}
              </span>
            </Col>
          </Row>
          <ITerminalWizardComponent
            sectionList={pdSectionList}
            activeSection={activeSection}
            validationLevel={fileRegistrationObject.validationLevel}
            onClick={(sectionNumber: number) => {
              setActiveSection(sectionNumber)
            }}
          />
          <Row className="section-layout">
            {activeSection === 1 && (
              <SectionOne
                fileRegistrationObject={fileRegistrationObject}
                onOk={handleOk}
                onCancel={handleCancel}
                onProceed={handleProceed}
                onModify={handleModify}
                onReject={(remark: string) => handleReject(remark)}
                onReturn={(remark: string) => handleReturn(remark)}
                onReload={getFileDetails}
              />
            )}
            {activeSection === 2 &&
              (fileRegistrationObject.status == 'Application Drafted' ||
              fileRegistrationObject.status == 'Application Modify Draft' ? (
                <SectionTwo
                  fileRegistrationObject={fileRegistrationObject}
                  onOk={handleOk}
                  onNext={(registerFile: FileRegistrationModel) => {
                    handleSectionTwo('next', registerFile)
                  }}
                  onSave={(registerFile: FileRegistrationModel) => {
                    handleSectionTwo('save', registerFile)
                  }}
                  onNextSection={handleNextClick}
                />
              ) : (
                <SectionTwoView
                  fileRegistrationObject={fileRegistrationObject}
                  onOk={handleOk}
                />
              ))}
            {activeSection === 3 &&
              (fileRegistrationObject.status == 'Application Drafted' ||
              fileRegistrationObject.status == 'Application Modify Draft' ? (
                <SectionThree
                  fileRegistrationObject={fileRegistrationObject}
                  onOk={handleOk}
                  onNext={(
                    aggrivedPersonDetails: PdAggrivedPersonDetailsModel
                  ) => {
                    handleSectionThree('next', aggrivedPersonDetails)
                  }}
                  onSave={(
                    aggrivedPersonDetails: PdAggrivedPersonDetailsModel
                  ) => {
                    handleSectionThree('save', aggrivedPersonDetails)
                  }}
                  onNextSection={handleNextClick}
                />
              ) : (
                <SectionThreeView
                  fileRegistrationObject={fileRegistrationObject}
                  onOk={handleOk}
                />
              ))}
            {activeSection === 4 &&
              (fileRegistrationObject.status == 'Application Drafted' ||
              fileRegistrationObject.status == 'Application Modify Draft' ? (
                <SectionFour
                  fileRegistrationObject={fileRegistrationObject}
                  onOk={handleOk}
                  onNext={() => {
                    handleSectionFour('next')
                  }}
                  onSave={() => {
                    handleSectionFour('save')
                  }}
                  onNextSection={handleNextClick}
                />
              ) : (
                <SectionFourView
                  fileRegistrationObject={fileRegistrationObject}
                  onOk={handleOk}
                />
              ))}
            {activeSection === 5 &&
              (fileRegistrationObject.status == 'Application Drafted' ||
              fileRegistrationObject.status == 'Application Modify Draft' ? (
                <SectionFive
                  fileRegistrationObject={fileRegistrationObject}
                  onOk={handleOk}
                  onNext={(formData: FormData) => {
                    handleSectionFive('submit', formData)
                  }}
                  onSave={(formData: FormData) => {
                    handleSectionFive('save', formData)
                  }}
                />
              ) : (
                <SectionFiveView
                  fileRegistrationObject={fileRegistrationObject}
                  onOk={handleOk}
                />
              ))}
          </Row>
        </>
      )}
      {showModal && (
        <DialogModal
          name="Application Creation"
          body={
            <div className="custom-dialog-body">
              <p>{getSectionFiveSuccessMessage(fileRegistrationObject)}</p>
              <p>
                {`Application Number : ${fileRegistrationObject.referenceNumber}`}
              </p>
            </div>
          }
          onOk={() => {
            history.goBack()
          }}
        />
      )}
    </>
  )
}

export default PdFileRegistration
